// 錯誤轉成可顯示文案（同舊版 utils.apiErrorMessage）。跟 request.js 分開，request 才不用引用主語言包。
// 網路層失敗 fetch 會拋 TypeError；其餘 message 是後端錯誤字串 = form ns 的 i18n key；沒有訊息就顯示 fallback
import { t } from '@/i18n'

export function apiErrorMessage(err, fallback = 'Failed') {
  if (err instanceof TypeError) return t('form', 'Connection failed, please try again later')
  return err?.message ? t('form', err.message) : t('form', fallback)
}
